export default __webpack_public_path__ + "static/media/ia.47eea781.jpg";